import * as React from 'react';
import { Tooltip, Icon } from 'components/antd';
import styles from './JourneyNotes.module.scss';

interface Props {
	text: string;
}

export const JourneyNotes: React.FC<Props> = ({ text }) => (
	<Tooltip title={text}>
		<span className={styles.journeyNotes}>
			<Icon type="note" />
		</span>
	</Tooltip>
);
